/* eslint-disable react/prop-types */
import React, { useState } from 'react';

const initialContext = {
    config: {},
    legal_url: '',
    model_url: '',
    available_cars: [],
    stations: [],
    time_options: [
        {
            value: 12,
            label: '12 Meses',
            enabled: true
        }, {
            value: 24,
            label: '24 Meses',
            enabled: true
        }, {
            value: 36,
            label: '36 Meses',
            enabled: true
        }, {
            value: 48,
            label: '48 Meses',
            enabled: true
        }
    ],
    selected_time: {
        value: 12,
        label: '12 Meses'
    },
    distance_options: [
        {
            value: 10000,
            label: '10.000 km',
            enabled: false,
        }, {
            value: 12000,
            label: '12.000 km',
            enabled: true
        }, {
            value: 15000,
            label: '15.000 km',
            enabled: true
        }, {
            value: 18000,
            label: '18.000 km',
            enabled: true
        }, {
            value: 20000,
            label: '20.000 km',
            enabled: true
        }, {
            value: 24000,
            label: '24.000 km',
            enabled: true
        }
    ],
    selected_distance: {
        value: 10000,
        label: '10.000 km',
    },
    downpayment_percentage: 0,
    selected_car: null,
    social_media: null,
    simulation_results: null,
    simulation_total: 0,
    min_price: {
        simulation12: null,
        simulation24: null,
        simulation36: null,
        simulation48: null,
    },
    personal_data: {
        id: 0,
        full_name: "",
        email: "",
        rut: "",
        phone_number: "",
        city_id: 0,
        city: "",
        station: 0,
        model: "",
        period: "",
        kms: "",
        contact: "",
    },
    error_notification: null
}

const CotizadorContext = React.createContext([{}, () => {}])

const CotizadorProvider = props => {
    const [state, setState] = useState(initialContext)
    return <CotizadorContext.Provider value={[state, setState]}>{props.children}</CotizadorContext.Provider>
}

export {CotizadorContext, CotizadorProvider, initialContext}